<template>
  <div class="d-flex flex-column flex-grow-1 fill-height" :class="{'background' : showGraphics}">
    <img :src="$root.getSetting('login_page_logo')" class="headerImage" v-if="$vuetify.breakpoint.mdAndUp && showGraphics"/>
    <v-container class="fill-height align-sm-center loginContent">
      <div class="mx-sm-auto mb-sm-8 loginBox" :class="{'loginBoxSmall': !showGraphics || !showLeftColumn}">
        <v-row :class="{'mainBorder fill-height my-4': $vuetify.breakpoint.mdAndUp && border}" no-gutters>
          <v-col class="primary white--text py-8 d-flex align-center" cols="4" v-if="$vuetify.breakpoint.mdAndUp && showGraphics && showLeftColumn">
            <img class="graphics" src="static/images/vevox/vevox_features_roundels.png" alt="">
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndUp && showGraphics && showLeftColumn? 8 : 12" class="pt-0 pr-0 bkg pb-4" :class="{'white': border}">
            <div class="text-center mt-4" v-if="boxLogo && $root.getSetting('login_page_logo') != null && ($vuetify.breakpoint.smAndDown || !showGraphics)">
              <img :src="$root.getSetting('login_page_logo')" class="logo"/>
            </div>
            <slot name="content"></slot>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <div v-if="showGraphics" v-show="$vuetify.breakpoint.mdAndUp">
        <img class="leftImage" src="static/images/vevox/paint_pattern_left3.svg" alt="">
        <img class="rightImage" src="static/images/vevox/paint_pattern_left3.svg" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginExtraPage',
  components: {
  },
  props: {
    showLeftColumn: { type: Boolean, required: false, default: true },
    border: { type: Boolean, default: true },
    boxLogo: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
    }
  },
  computed: {
    showGraphics() {
      return this.$root.getSetting('show_login_page_graphics');
    }
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped lang="scss">
.buttondiv {
  text-align: center;
}

.background {
  background: white !important;
}

.loginContent {
  max-width: 960px !important;
  z-index: 1;
  position: relative;
}

.loginBox {
  width: 100%;
}

.loginBoxSmall {
  max-width: 600px;
}

.mainBorder {
  border: 1px solid #e0e0e0;
}

.logo {
  max-width: 160px;
}

.headerImage {
  position: absolute;
  width: 128px;
  margin-left: 32px;
  margin-top: 24px;
}

.leftImage {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: auto;
  z-index: 0;
}

.rightImage {
  position: fixed;
  top: 0;
  right: 0;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  height: 100vh;
  width: auto;
  z-index: 0;
}

.graphics {
  width: 100%;
  height: auto;
}

.bkg {
  color: inherit;
}

@media only screen and (max-width: 1366px) and (max-height: 740px) {
   .headerImage {
    display: none;
  }
}

@media only screen and (max-width: 1600px) {
  .headerImage {
    margin-left: 24px;
    width: 112px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginExtraPage.vue